import {ComponentProps} from 'react';
import {CheckboxStyled} from './index.styled';

type Props = ComponentProps<typeof CheckboxStyled>;

export function Checkbox(props: Props) {
	return <CheckboxStyled selected={props.checked === 'indeterminate' ? false : props.checked} {...props} />;
}
